import { render, staticRenderFns } from "./TalentEmailView.vue?vue&type=template&id=70ebd829"
import script from "./TalentEmailView.vue?vue&type=script&lang=ts"
export * from "./TalentEmailView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports